import Queue from './Queue';
import safeStorage from './SafeStorage';


const Logger = (function(c){
  const rollingLogs = new Queue();
  
  const consoleOut = function(args, type)
  {
    let settings = null;
    try {
      const state = safeStorage.getItem('state');
      if (state) {
        settings = JSON.parse(state);
      }
    } catch (e) {
      // Gracefully handle any Storage/JSON exception in Safari Private Browsing mode
    }

    rollingLogs.enqueue(JSON.stringify(args));
    
    if (settings && settings['debugEnabled']) {
        args.forEach((v) => {
          c[type](v);
        }); 
    }
  }
  return {
    dump: function()
    {
      consoleOut(rollingLogs);
      return rollingLogs;
    },
    debug: function(...args)
    {
      consoleOut(args, 'log');
    },
    error: function(...args)
    {
      consoleOut(args, 'error');
    },
    warn: function(...args)
    {
      consoleOut(args, 'warn');
    },
    log: function(...args)
    {
      // consoleOut(arguments, 'log');
      consoleOut(args, 'log');
    },
    info: function(...args)
    {
      consoleOut(args, 'log');
    }
  }
})(console);

export default Logger;